module.exports = __webpack_public_path__ + "img/verified.3a7dd2f9.svg";